const StarterPack = () => import("@/modules/StarterPack/views/StarterPack.vue");

export default [
    {
        component: StarterPack,
        name: "StarterPack",
        path: "/project/:id/GCB2/starterPack",
        props: true,
    },
];
